import React, { createContext, useState } from "react"
import { get, post, put } from "utils/apiClient"

const API_PATH = 'locations/addressmgmt'

const TmsLocationCreationContext = createContext()

function Provider({ children }) {
    const [records, setRecords] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError]     = useState(false)

    const fetchRecords = async () => {
        setLoading(true)
        try {
            // Fetch only tms_location_creation jobs
            const response = await get(`${API_PATH}?feature=jobs&job_type=tms_location_creation`)
            setRecords(response || [])
        } catch (err) {
            console.error(err)
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    const createJob = async (payload) => {
        return await post(`${API_PATH}?feature=upload-file`, payload)
    }

    const getRecord = async (jobId) => {
        return await get(`${API_PATH}?feature=job-detail&job_id=${jobId}`)
    }

    // Step 2: save column mappings; returns { job_id, distinct_appt_systems }
    const saveColumnMappings = async (jobId, columnMappings) => {
        return await put(`${API_PATH}?feature=job-detail`, {
            job_id:          jobId,
            column_mappings: columnMappings,
        })
    }

    // Step 3: save appt-system mappings and start SFN
    const saveApptMappings = async (jobId, apptSystemMappings) => {
        return await put(`${API_PATH}?feature=appt-mappings`, {
            job_id:               jobId,
            appt_system_mappings: apptSystemMappings,
        })
    }

    const listApptSystems = async () => {
        return await get(`${API_PATH}?feature=appt-systems`)
    }

    const refreshDownloadUrl = async (jobId) => {
        const response = await get(`${API_PATH}?feature=download-file&job_id=${jobId}`)
        return response?.download_url
    }

    const uploadFileToS3 = async (presignedUrl, file) => {
        const response = await fetch(presignedUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
        })
        if (!response.ok) throw new Error('File upload to S3 failed')
    }

    const valueToShare = {
        records,
        loading,
        error,
        setError,
        fetchRecords,
        createJob,
        getRecord,
        saveColumnMappings,
        saveApptMappings,
        listApptSystems,
        refreshDownloadUrl,
        uploadFileToS3,
    }

    return (
        <TmsLocationCreationContext.Provider value={valueToShare}>
            {children}
        </TmsLocationCreationContext.Provider>
    )
}

export { Provider }
export default TmsLocationCreationContext
